import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["item", "toggleButton", "buttonText", "buttonIcon"]
  static values = {
    threshold: { type: Number, default: 5 },
    expanded: { type: Boolean, default: false }
  }

  connect() {
    this.updateVisibility()
  }

  toggle() {
    this.expandedValue = !this.expandedValue
    this.updateVisibility()
  }

  updateVisibility() {
    const items = this.itemTargets
    const threshold = this.thresholdValue
    const hiddenCount = items.length - threshold

    // If we have more items than threshold
    if (items.length > threshold) {
      items.forEach((item, index) => {
        if (index >= threshold) {
          item.classList.toggle("hidden", !this.expandedValue)
        }
      })

      // Update button text
      if (this.hasButtonTextTarget) {
        if (this.expandedValue) {
          this.buttonTextTarget.textContent = this.buttonTextTarget.dataset.showLess || "Voir moins"
        } else {
          const showMoreText = this.buttonTextTarget.dataset.showMore || "Voir {count} autres"
          this.buttonTextTarget.textContent = showMoreText.replace("{count}", hiddenCount)
        }
      }

      // Update button icon rotation
      if (this.hasButtonIconTarget) {
        this.buttonIconTarget.classList.toggle("rotate-180", this.expandedValue)
      }

      // Show the toggle button
      if (this.hasToggleButtonTarget) {
        this.toggleButtonTarget.classList.remove("hidden")
      }
    } else {
      // Hide toggle button if not needed
      if (this.hasToggleButtonTarget) {
        this.toggleButtonTarget.classList.add("hidden")
      }
    }
  }
}
